type FeatureFlag<T> = {
    key: string;
    defaultValue: T;
};

export const UB_ASSISTANT_ENABLED: FeatureFlag<boolean> = {
    key: "ub-assistant-enabled",
    defaultValue: false,
};

export const SHOW_BETA_STYLES: FeatureFlag<boolean> = {
    key: "ub-prospect-guidance-ui-show-beta-styles",
    defaultValue: false,
};

export const SHOW_SUGGESTED_QUESTIONS: FeatureFlag<boolean> = {
    key: "ub-prospect-guidance-ui-show-suggested-questions",
    defaultValue: false,
};

export const SHOW_STANDALONE_CONTEXT: FeatureFlag<boolean> = {
    key: "ub-prospect-guidance-ui-show-standalone-context",
    defaultValue: false,
};

export const SHOW_CONVERSATION_FEEDBACK: FeatureFlag<boolean> = {
    key: "ub-prospect-guidance-ui-show-conversation-feedback",
    defaultValue: false,
};

export const UB_CONVERSATION_LEAD_GENERATOR_ENABLED: FeatureFlag<boolean> = {
    key: "assistant-collect-leads",
    defaultValue: false,
};

export const DISABLE_CTA_ACTIONS_ON_MOBILE: FeatureFlag<boolean> = {
    key: "ub-prospect-guidance-disable-cta-actions-on-mobile",
    defaultValue: false,
};
